export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M6.5 9V5h-4v4zm0 5v-4h-4v4zm5 0v-4h-4v4zm5 0v-4h-4v4zm-5-5V5h-4v4zm1 0h4V5h-4zm9 5v-4h-4v4zm-15 5v-4h-4v4zm5 0v-4h-4v4zm5 0v-4h-4v4zm5 0v-4h-4v4zm-4-10h4V5h-4z\"/>"
};